import { AcceptItemRequestState } from './acceptItemRequest.types'

const initialState: AcceptItemRequestState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
